import { useState } from "react";
import { Menu, X } from "./icons";
import { Outlet, Link } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';


function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const [isMobileDropdownOpen, setIsMobileDropdownOpen] = useState(false)

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-white shadow-sm">
      
      <div className="w-full mx-auto flex h-24 items-center justify-between px-8 md:px-8">
        <div className="flex items-center gap-2 md:gap-4">
          <button className="md:hidden rounded-full p-2 hover:bg-gray-100" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
          <a href="/" className="flex items-center gap-2">
            <img
                src="https://glenrockchamberofcommerce.com/wp-content/uploads/2025/02/Food-Universe-Logo.jpg"
                alt="Food Universe Logo"
                className="h-16 w-auto"
              />
            <span className="text-3xl font-extrabold tracking-tight text-newblue drop-shadow-sm">Food Universe</span>
          </a>
        </div>
        <nav className="hidden md:flex items-center gap-10">
          <div
            className="relative"
            onMouseEnter={() => setIsDropdownOpen(true)}
            onMouseLeave={() => setIsDropdownOpen(false)}
          >
            <button className="text-lg font-bold hover:text-newblue">
              Departments
            </button>
            <div className="absolute left-0 top-full h-3 w-full bg-transparent"></div>

            {isDropdownOpen && (
              <div className="absolute left-0 mt-2 min-w-52 bg-white border rounded-lg shadow-lg overflow-hidden">
                <Link
                  to="/departments/produce"
                  className="block px-4 py-3 text-md font-medium hover:bg-gray-100 rounded-t-lg"
                >
                  Produce
                </Link>
                <Link
                  to="/departments/meat"
                  className="block px-4 py-3 text-md font-medium hover:bg-gray-100"
                >
                  Meat
                </Link>
                <Link
                  to="/departments/deli"
                  className="block px-4 py-3 text-md font-medium hover:bg-gray-100"
                >
                  Deli
                </Link>
                     <Link
                  to="/departments/kosher"
                  className="block px-4 py-3 text-md font-medium hover:bg-gray-100"
                >
                  Kosher
                </Link>
                <Link
                  to="/departments/liquor"
                  className="block px-4 py-3 text-md font-medium rounded-b-lg hover:bg-gray-100"
                >
                  Liquor
                </Link>
              </div>
            )}
          </div>

          <a href="#" className="text-lg font-bold hover:text-newblue">
            <Link to='/locate'>Locate</Link>
          </a>
          <HashLink smooth to="/#circular" className="text-lg font-bold hover:text-newblue">
            Circular
          </HashLink>
          <a href="#" className="text-lg font-bold hover:text-newblue">
            <Link to='/about'>About Us</Link>
          </a>
          <a href="#" className="text-lg font-bold hover:text-newblue">
            <Link to='/contact'>Contact</Link>
          </a>
        </nav>
      </div>

      {isMenuOpen && (
        <div className="absolute top-16 left-0 w-full bg-white border-b shadow-lg md:hidden">
          <nav className="container mx-auto flex flex-col px-4 py-4">

            {/* ✅ Mobile Dropdown */}
            <button
              onClick={() => setIsMobileDropdownOpen(!isMobileDropdownOpen)}
              className="py-2 text-sm font-bold text-left w-full hover:text-newblue flex justify-between items-center"
            >
              Departments
              <span>{isMobileDropdownOpen ? "▲" : "▼"}</span>
            </button>

            {isMobileDropdownOpen && (
              <div className="flex flex-col pl-4">
                <Link to="/departments/produce" className="py-2 text-sm hover:text-newblue">
                  Produce
                </Link>
                <Link to="/departments/meat" className="py-2 text-sm hover:text-newblue">
                  Meat
                </Link>
                <Link to="/departments/deli" className="py-2 text-sm hover:text-newblue">
                  Deli
                </Link>
                <Link to="/departments/kosher" className="py-2 text-sm hover:text-newblue">
                  Kosher
                </Link>
                <Link to="/departments/liquor" className="py-2 text-sm hover:text-newblue">
                  Liquor
                </Link>
              </div>
            )}

            <a className="py-2 text-sm font-bold hover:text-newblue">
              <Link to='/locate'>Locate</Link>
            </a>
            <HashLink smooth to="/#circular" className="py-2 text-sm font-bold hover:text-newblue">
              Circular
            </HashLink>
            <a className="py-2 text-sm font-bold hover:text-newblue">
              <Link to='/about'>About Us</Link>
            </a>
            <a className="py-2 text-sm font-bold hover:text-newblue">
              <Link to='/contact'>Contact</Link>
            </a>
          </nav>
        </div>
      )}

      <Outlet />
    </header>
  )
}

export default Header
